<!--
A Google Maps custom toolbar to move the map level (building floor up and down); and to show and use accessible routes.
Usage:
  <MapToolbar useAccessibleRoutesEnabled="true"
    @showAccessibleRoutesChanged="onShowAccessibleRoutesChanged()"
    @showAccessibleRoutesChanged="onShowAccessibleRoutesChanged()" />
@author bmk11u, crm4f
-->
<template>
  <div>
    <nav id="mapToolbarNav" class="nav navbar bg-white pl-0 pr-0 mt-2 mr-2 border">
      <div :class="{ 'disabled': !props.useAccessibleRoutesEnabled }" @click="showAccessibleRoutesModal = true">
        <a class="nav-link text-dark pl-2 pr-2 font-weight-bold" data-toggle="modal" data-target="#accessibleRoutesModal"
          href="JavaScript:void(0)">Accessible Routes</a>
      </div>
    </nav>
    <NewModalPopup @close="showAccessibleRoutesModal = false" v-if="showAccessibleRoutesModal" id="accessibleRoutesModal" title="Accessible Routes" :showX="true">
      <div class="btn-group-vertical w-100">
        <button class="btn rounded-0" @click="showAccessibleRoutesChanged()"
          :class="{ 'btn-primary': showAccessibleRoutes, 'btn-light': !showAccessibleRoutes }">Show routes</button>
        <button class="btn rounded-0" @click="useAccessibleRoutesChanged()"
          :disabled="!useAccessibleRoutesEnabled"
          :class="{ 'btn-primary': useAccessibleRoutes, 'btn-light': !useAccessibleRoutes }">Use routes</button>
      </div>
    </NewModalPopup>
  </div>
</template>

<script setup>
import NewModalPopup from '@/components/NewModalPopup.vue'
import { ref, defineProps, defineEmits } from 'vue'

const props = defineProps({
  useAccessibleRoutesEnabled: {
    type: String
  }
})

const emit = defineEmits(['useAccessibleRoutesChanged', 'showAccessibleRoutesChanged'])


const showAccessibleRoutes = ref(false)
const useAccessibleRoutes = ref(false)
const showAccessibleRoutesModal = ref(false)

function showAccessibleRoutesChanged () {
  showAccessibleRoutesModal.value = false
  showAccessibleRoutes.value = !showAccessibleRoutes.value
  emit('showAccessibleRoutesChanged', showAccessibleRoutes.value)
}
    
function useAccessibleRoutesChanged () {
  showAccessibleRoutesModal.value = false
  useAccessibleRoutes.value = !useAccessibleRoutes.value
  emit('useAccessibleRoutesChanged', useAccessibleRoutes.value)
}

</script>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
